import { CommodityAssignee, PersonaType } from '@bechtel/types';
import { filter, map } from 'lodash';

export function useWeldAssignees(commodityAssignees: CommodityAssignee[]) {
  const assignedCrewMembers = commodityAssignees
    ? filter(commodityAssignees, (assignee) => {
        return assignee.personaType === PersonaType.FOREMAN || assignee.personaType === PersonaType.FIELD_WELD_ENGINEER;
      })
  : [];
  const assignedForemen: CommodityAssignee[] = filter(
    assignedCrewMembers,
    (item: CommodityAssignee) => item?.personaType === PersonaType.FOREMAN
  );
  const foremanSupervisors: CommodityAssignee[] = [];
  if (assignedForemen.length > 0) {
    map(assignedForemen, (foreman) => {
      if (foreman.assignee?.supervisor && foreman.assignee.supervisor.id) {
        foremanSupervisors.push({
          personaType: foreman.assignee.supervisor.persona,
          assignee: foreman.assignee.supervisor,
        });
        if (foreman.assignee.supervisor?.supervisor && foreman.assignee.supervisor.supervisor?.id) {
          foremanSupervisors.push({
            personaType: foreman.assignee.supervisor.supervisor.persona,
            assignee: foreman.assignee.supervisor.supervisor,
          });
        }
      }
    });
  }
  return [...assignedCrewMembers, ...foremanSupervisors];
}
